import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {AlertService, EventManager, JhiLanguageService} from 'ng-jhipster';
import {Formation} from './formation.model';
import {FormationPopupService} from './formation-popup.service';
import {FormationService} from './formation.service';
import {Response} from '@angular/http';

@Component({
    selector: 'jhi-formation-new-dialog',
    templateUrl: './formation-new-dialog.component.html'
})
export class FormationNewDialogComponent implements OnInit {

    formations: Formation[];
    isSaving: boolean;
    filteredList: Formation[];
    selectedFormations = [];
    private lastRowIndex: number;

    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private formationService: FormationService,
        private eventManager: EventManager,
        private router: Router,
        private alertService: AlertService,
    ) {
        this.jhiLanguageService.setLocations(['formation']);
    }

    ngOnInit() {
        this.isSaving = true;
        this.formationService.queryNewFormationsComposant().subscribe(
            (res: Response) => {
                this.formations = res.json();
                // this.formations = this.formations.filter(f => f.id == null);
                this.assignCopy();
                this.isSaving = false;
                // on passe un index négatif aux nouvelles formations
                let indexFormationView: number = -1;
                this.formations.filter(f => f.id == null).forEach(fv => {
                    fv.id = indexFormationView;
                    indexFormationView--;
                });
            },
            (res: Response) => {
                this.isSaving = false;
                this.onError(res);
                this.isSaving = false;
            });
    }

    clear() {
        this.activeModal.dismiss('cancel');
    }

    assignCopy() {
        this.filteredList = Object.assign([], this.formations);
    }

    filterFormations(value) {
        if (!value) { // when empty
            this.assignCopy();
        }
        this.filteredList = Object.assign([], this.formations).filter(
            item => item.libelle.toLowerCase().indexOf(value.toLowerCase()) > -1
        );
    }

    selectFormation(event, formation, index) {
        this.isSaving = true;
        // In popup Paramétrer une nouvelle formation, selections des formations!
        if (event.shiftKey && this.lastRowIndex > -1 && this.lastRowIndex !== index) {
            // Si l'utilisateur a appuyé sur la touche SHIFT, sélectionner toutes les formations entre les 2 index!
            if (this.lastRowIndex < index) {
                for (let i = this.lastRowIndex + 1; i <= index; i++) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            } else if (this.lastRowIndex > index) {
                for (let i = this.lastRowIndex - 1; i >= index; i--) {
                    this.addSelectedFormation(this.filteredList[i], i);
                }
            }
        } else {
            this.addSelectedFormation(formation, index);
            this.lastRowIndex = index;
        }
    }

    save() {
        this.isSaving = false;
        let newSelectedFormations = [];
        this.selectedFormations.forEach(formationId => {
            if (formationId < 0) {
                let formation: Formation = this.formations.find(forma => forma.id == formationId);
                formation.id = null;
                this.formationService.create(formation).subscribe((newFormation: Formation) => {
                    newSelectedFormations.push(newFormation.id);
                });

            } else {
                newSelectedFormations.push(formationId);
            }
        });
        this.activeModal.dismiss('cancel');
        setTimeout(() => this.router.navigate(['/formation/' + newSelectedFormations]), 500);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    /**
     * Si la formation a deja un ID, l'ajouter à la liste des formations sélectionnées
     * Sinon il faut la créer dans la table formation avant de l'ajouter
     * @param formation sélectionnée
     * @param index de la formation dans la liste
     */
    private addSelectedFormation(formation, index) {
        this.pushToSelectedFormations(formation.id);
        // if (formation.id) {
        //     this.pushToSelectedFormations(formation.id);
        // } else {
        //     this.formationService.create(formation).subscribe(ff => {
        //         this.filteredList[index] = ff;
        //         this.pushToSelectedFormations(ff.id);
        //     });
        // }
    }

    /**
     * Sélectionner / Déselectionner une formation dans la liste
     * @param id de la formation
     */
    private pushToSelectedFormations(id) {
        if (this.selectedFormations.indexOf(id) < 0) {
            this.selectedFormations.push(id);
        } else {
            this.selectedFormations.splice(this.selectedFormations.indexOf(id), 1);
        }
        this.isSaving = false;
    }
}

@Component({
    selector: 'jhi-formation-new-popup',
    template: ''
})
export class FormationNewPopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private formationPopupService: FormationPopupService
    ) {
    }

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.formationPopupService
                .open(FormationNewDialogComponent);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/formation/formation-new-dialog.component.ts